import { render, staticRenderFns } from "./SpecialPriceAdjDetails_Details.vue?vue&type=template&id=1464865e&"
import script from "./SpecialPriceAdjDetails_Details.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports